import React, { useMemo } from 'react';
import { Text } from '../Text';
import { createHighlighted, createUnhighlighted, isValidQuery } from './utils';
export var PredictedHeader = function (_a) {
    var dataTestId = _a["data-testid"], queryString = _a.queryString, fullString = _a.fullString;
    var locations = useMemo(function () {
        if (!isValidQuery(queryString))
            return;
        return Array.from(fullString.toLowerCase().matchAll(RegExp(queryString.toLowerCase(), 'gi'))).map(function (a) { return a.index; });
    }, [fullString, queryString]);
    return (React.createElement(React.Fragment, null, fullString.toLowerCase().includes(queryString.toLowerCase()) &&
        queryString != '' ? (locations.map(function (locationOfQueryString, index) { return (React.createElement("span", { key: index, "data-testid": dataTestId },
        createUnhighlighted(fullString, locations[index - 1] + queryString.length, locationOfQueryString),
        createHighlighted(fullString, locationOfQueryString, queryString.length),
        index === locations.length - 1 &&
            createUnhighlighted(fullString, locationOfQueryString + queryString.length, fullString.length))); })) : (React.createElement(Text, { size: 2 }, fullString))));
};
